/**
 * Estados de carga da mesa eletrônica (E74.F3).
 *
 * Mesmo recorte de `LaudoCasoPageStates`: erro, carregando e vazio saem da
 * página para que ela seja layout. Sem isso, as três ramificações somadas às da
 * lista estouram o limite de complexidade do lint — que aqui está certo, porque
 * a página passa a ser difícil de ler.
 */
import { ptBR } from '@/i18n/pt-BR';
import type { ExameEletronicoCcbData } from '@/lib/exame_eletronico';

const t = ptBR.mesaEletronica;

export interface MesaEletronicaEstadoProps {
  erroGlobal: string | null;
  ccbs: ExameEletronicoCcbData[] | null;
}

export function MesaEletronicaEstado({
  erroGlobal,
  ccbs,
}: MesaEletronicaEstadoProps): JSX.Element | null {
  if (erroGlobal !== null) {
    return (
      <p
        className="mt-sc-4 border border-danger bg-danger-50 px-sc-3 py-sc-2 text-body-sm text-danger-700"
        role="alert"
        data-testid="mesa-eletronica-error"
      >
        {erroGlobal}
      </p>
    );
  }
  if (ccbs === null) {
    return (
      <p className="mt-sc-6 text-body-md text-fg-muted" data-testid="mesa-eletronica-loading">
        {t.loading}
      </p>
    );
  }
  if (ccbs.length === 0) {
    return (
      <p className="mt-sc-6 text-body-md text-fg-muted" data-testid="mesa-eletronica-sem-ccbs">
        {t.semCcbs}
      </p>
    );
  }
  return null;
}
